"use client"

import { useTranslations } from "@/lib/i18n/client"

export function SiteFooter() {
  const t = useTranslations("footer")
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-brand bg-white">
      <div className="mx-auto max-w-6xl px-4 py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <span className="text-lg font-semibold text-brand">{t("brand")}</span>
            <p className="mt-3 max-w-sm text-sm text-muted-foreground">{t("description")}</p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-brand">{t("productTitle")}</h3>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="#trade" className="hover:text-brand">
                  {t("links.trade")}
                </a>
              </li>
              <li>
                <a href="#trc20" className="hover:text-brand">
                  {t("links.trc20")}
                </a>
              </li>
              <li>
                <a href="#security" className="hover:text-brand">
                  {t("links.security")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-brand">{t("supportTitle")}</h3>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="#faq" className="hover:text-brand">
                  {t("links.faq")}
                </a>
              </li>
              <li>
                <a href="mailto:support@tron-usdt-desk.io" className="hover:text-brand">
                  {t("links.contact")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-brand pt-6 text-xs text-muted-foreground sm:flex-row">
          <p>{t("copyright", { year })}</p>
          <p>{t("disclaimer")}</p>
        </div>
      </div>
    </footer>
  )
}
